import {Component, ChangeDetectionStrategy, signal, computed} from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

// Tier 4: removed Wijmo `* as wjcGrid` import — AG Grid via the wrapper handles
// all grid rendering. The 2 mini-grids (GREASE TRAP + JETING) now read from
// signals instead of being mutated via the imperative `flex.rows.push` API.

import { TicketService } from '../../../services/eco/ticket.service';
import { ClientsService } from '../../../services/customers/clients.service';
import { UsuarioService } from '../../../services/usuario.service';
import { UtilsService } from '../../../services/eco/utils.service';

import { ToastrService } from 'ngx-toastr';

import {
  createActionColumn,
  createPlainColumn
} from '../../../shared/components/kite-grid/column-utils/column-utils';

@Component({
    selector: 'app-create-oticket',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './create-oticket.component.html',
    styleUrls: ['./create-oticket.component.scss'],
    standalone: false
})
export class CreateOticketComponent {

  // Tier 4: removed `@ViewChild('grease') flexGrease` and `@ViewChild('jeting') flexJeting`
  // — those were Wijmo-specific. The 2 mini-grids now read from signal-backed arrays
  // and are mutated via `signal.update(arr => [...arr, row])` instead of the
  // imperative `flex.rows.push(...)` call.

  readonly greaseSource = signal<any[]>([]);
  readonly jetingSource = signal<any[]>([]);
  clientId: any;
  graseData: any = [];
  jetingData: any = [];
  people: any = [];
  locations: any = [];

  ticketForm: any;

  fields = {
    client_id: [''],
    client_name: [''],
    total_ticket_cost: [''],
    company_group: [''],
    primary_client_name: [''],
    requested_by: [''],
    fullname_request_by: [''],
    date_begin: [''],
    location_type: [''],
    gallons: [''],
    price: [''],
    size_l: [''],
    size_w: [''],
    size_h: [''],
    available_grease: [''],
    frecuenty_grease: [''],
    location_descripcion: [''],
    grease_service_descriptions: [''],
    location_jeting: [''],
    distance: [''],
    location_type_jeting: [''],
    jeting_price: [''],
    available_jeting: [''],
    frecueny_jeting: [''],
    jeting_service_description: [''],
    clean_area: [''],
    available_clean: [''],
    frecuency_clean: [''],
    clean_service_description: [''],
  }

  // Tier 4: AG Grid column defs for the 2 mini-grids. The action column carries
  // a single button (legacy behavior — the button was a phantom since
  // `modalViewImage` was never defined in the template; the migration keeps
  // the no-op semantics via a no-op `viewImageBtn` click handler).
  greaseColumnDefs: any[] = [];
  jetingColumnDefs: any[] = [];

  constructor(
    private ticketService: TicketService,
    private clientService: ClientsService,
    private fb: UntypedFormBuilder,
    private activatedRoute: ActivatedRoute,
    private userService: UsuarioService,
    private utils: UtilsService,
    private toastr: ToastrService,

  ) {
    this.greaseColumnDefs = [
      createActionColumn({
        width: 60,
        buttons: [{
          icon: 'fa-info-circle',
          title: 'View image',
          ariaLabel: 'view image',
          classes: 'view-image-btn'
        }]
      }),
      createPlainColumn({ field: 'size',                 headerName: 'Size',                width: 150, cellClass: 'ag-cell-center' }),
      createPlainColumn({ field: 'gallons',              headerName: 'Gallons',             width: 150, cellClass: 'ag-cell-center' }),
      createPlainColumn({ field: 'frecuency',            headerName: 'Frequency',          width: 150, cellClass: 'ag-cell-center' }),
      createPlainColumn({
        field: 'location_description',
        headerName: 'Location description',
        flex: 1,
        cellClass: 'ag-cell-left'
      })
    ];

    this.jetingColumnDefs = [
      createActionColumn({
        width: 60,
        buttons: [{
          icon: 'fa-info-circle',
          title: 'View image',
          ariaLabel: 'view image',
          classes: 'view-image-btn'
        }]
      }),
      createPlainColumn({ field: 'location',              headerName: 'Location',            width: 150, cellClass: 'ag-cell-center' }),
      createPlainColumn({ field: 'price',                headerName: 'Price',              width: 150, cellClass: 'ag-cell-center' }),
      createPlainColumn({ field: 'frecuency',            headerName: 'Frequency',          width: 150, cellClass: 'ag-cell-center' }),
      createPlainColumn({
        field: 'location_description',
        headerName: 'Location description',
        flex: 1,
        cellClass: 'ag-cell-left'
      })
    ];
  }

  ngOnInit(): void {
    this.ticketForm = this.fb.group(this.fields);
    this.clientId = this.activatedRoute.snapshot.paramMap.get('client') || '';
    this.loadDataClient();

    this.utils.getPeople().subscribe((data: any) => {
      this.people = data.people;
    });

    this.utils.getLocations().subscribe((data: any) => {
      this.locations = data.locations;
    });

  }

  async loadDataClient() {
    let clientById = await this.clientService.getAsyncById(this.clientId);

    this.ticketForm.patchValue({
      client_id:         clientById.client.ident_GUI,
      client_name:       clientById.client.name_client,
    });

  }

  createTicket() {

    let ticket = {
      client_id:                   this.ticketForm.get('client_id').value,
      client_oid:                  this.clientId,
      client_name:                 this.ticketForm.get('client_name').value,
      total_ticket_cost:           this.ticketForm.get('total_ticket_cost').value,
      msa:                         this.ticketForm.get('master_agreement').value,
      request_by:                  this.ticketForm.get('requested_by').value,
      date_begin:                  this.ticketForm.get('date_begin').value,
      user:                        this.userService.usuario.uid,
      // Tier 4: source from the signal (was: `this.graseData`).
      grease:                      this.greaseSource(),
      grease_services_descriptions: this.ticketForm.get('grease_service_descriptions').value,
      jeting:                      this.jetingSource(),
      jeting_services_descriptions: this.ticketForm.get('jeting_service_description').value,
      clean: {
        clean_area:                this.ticketForm.get('clean_area').value,
        available_clean:           this.ticketForm.get('available_clean').value,
        frecuency_clean:           this.ticketForm.get('frecuency_clean').value,
        clean_service_description: this.ticketForm.get('clean_service_description').value,
      }
    }

    this.ticketService.createTicket(ticket).subscribe((result: any) => {
      this.toastr.success('The ticket is created successfully.');
    })
  }

  async addToGreaseFlex() {
    const rowFlex = {
      size: `${await this.ticketForm.get('size_l').value} x ${await this.ticketForm.get('size_w').value} x ${await this.ticketForm.get('size_h').value}`,
      gallons:              await this.ticketForm.get('gallons').value,
      frecuency:            await this.ticketForm.get('frecuenty_grease').value,
      location_description: await this.ticketForm.get('location_descripcion').value,
      price:                await this.ticketForm.get('price').value
    }

    // Tier 4: signal update replaces the imperative `flexGrease.rows.push(new
    // wjcGrid.Row(rowFlex))`. AG Grid reads the signal via `[rowData]="..."`
    // and re-renders automatically.
    this.greaseSource.update(arr => [...arr, rowFlex]);
  }

  async addJetingFlex() {
    const rowFlex = {
      location:             await this.ticketForm.get('location_jeting').value,
      price:                await this.ticketForm.get('jeting_price').value,
      frecuency:            await this.ticketForm.get('frecueny_jeting').value,
      location_description: await this.ticketForm.get('location_type_jeting').value,
    };

    this.jetingSource.update(arr => [...arr, rowFlex]);
  }

  /**
   * Tier 4: (cellClicked) handler for the 2 mini-grids. The original
   * `viewImage(modal, listId, ev)` was a phantom — `modalViewImage` was never
   * defined in the template, so the click handler was effectively a no-op
   * (just `stopPropagation` + `preventDefault` on the event). The migration
   * preserves that semantics: the button is rendered, the click is captured,
   * and the handler returns without doing anything functional.
   */
  onCellClicked(_event: any): void {
    // intentional no-op — preserves the legacy phantom-button behaviour
  }
}
